import React from 'react';

export default class ListColumn extends React.Component {
  static defaultProps = {
    visible: true,
  };
}
